export const MindUpAdminMobileCompletedUserCounselMenu = ['전체', '완료', '노쇼 종료'];
